import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_DECENNALE',
  title: 'Déposer votre attestation décennale à la date d\'ouverture du chantier',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: `Le quitus de votre entreprise dans le cadre d’une opération n’est plus à jour ? 
    C’est peut-être que votre attestation décennale à la date de la déclaration d’ouverture de chantier pour cette opération n’est pas à jour… 
    Voici comment vous en assurer en 4 étapes…`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Repérez la date de la DOC sur votre opération'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_1.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Retrouvez votre entreprise dans l’organigramme de l’opération'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_2.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Affichez vos documents'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Cliquez sur les 3 petits points :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_3.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Puis sur Afficher vos documents :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Déposez votre attestation décennale'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Retrouvez l’attestation décennale manquante dans la liste des documents puis cliquez sur Déposer :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_5.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Déposez votre attestation décennale pour la bonne date d’ouverture du chantier'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_6.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Vos documents seront vérifiés et traités dans un délai de 48 heures.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Vous pouvez consulter l’état de tous vos documents depuis l’onglet Mes Documents :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Vous pouvez aussi déposer votre Attestation Décennale à la date de DOC depuis cet onglet, en cliquant sur Ajouter une nouvelle version :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_DECENNALE/FR_DEPOT_DECENNALE_8.png`
  }]
};
